import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebUserRecipientMappingMaintenanceRoutingModule } from './web-user-recipient-mapping-maintenance-routing.module';
import { WebUserRecipientMappingMaintenanceComponent } from './web-user-recipient-mapping-maintenance.component';
import { WurmFormComponent } from './wurm-form/wurm-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { WebUserDropdownModule } from 'src/app/core/custom-modules/dropdowns/web-user-dropdown/web-user-dropdown.module';
import { RecipientDropdownModule } from 'src/app/core/custom-modules/dropdowns/recipient-dropdown/recipient-dropdown.module';
import { WurmFilterComponent } from './wurm-filter/wurm-filter.component';
import { RecipientMultiselectDropdownModule } from 'src/app/core/custom-modules/dropdowns/recipient-multiselect-dropdown/recipient-multiselect-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    WebUserDropdownModule,
    RecipientDropdownModule,
    RecipientMultiselectDropdownModule,
    WebUserRecipientMappingMaintenanceRoutingModule
  ],
  declarations: [WebUserRecipientMappingMaintenanceComponent, WurmFormComponent, WurmFilterComponent],
  entryComponents: [WurmFilterComponent]
})
export class WebUserRecipientMappingMaintenanceModule { }
